export class SelectOrganization {
}

export class SelectOrganizationModel {
    refreshToken: string;
    organizationId: number;
}